export { default as ParagraphStyleView } from './paragraph-styles';
